import React from 'react';

export const DangerTriangle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 33"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.18805 14.5539C11.0787 7.65392 13.024 4.20459 16.1054 4.20459C19.1854 4.20459 21.132 7.65392 25.0227 14.5539L25.508 15.4126C28.7414 21.1459 30.3587 24.0126 28.8974 26.1086C27.436 28.2046 23.82 28.2046 16.5907 28.2046H15.62C8.39072 28.2046 4.77472 28.2046 3.31338 26.1086C1.85205 24.0126 3.46938 21.1459 6.70272 15.4126L7.18805 14.5539ZM16.1054 9.87126C16.3706 9.87126 16.625 9.97661 16.8125 10.1641C17 10.3517 17.1054 10.606 17.1054 10.8713V17.5379C17.1054 17.8031 17 18.0575 16.8125 18.245C16.625 18.4326 16.3706 18.5379 16.1054 18.5379C15.8402 18.5379 15.5858 18.4326 15.3983 18.245C15.2107 18.0575 15.1054 17.8031 15.1054 17.5379V10.8713C15.1054 10.606 15.2107 10.3517 15.3983 10.1641C15.5858 9.97661 15.8402 9.87126 16.1054 9.87126ZM16.1054 22.8713C16.459 22.8713 16.7981 22.7308 17.0482 22.4807C17.2982 22.2307 17.4387 21.8915 17.4387 21.5379C17.4387 21.1843 17.2982 20.8452 17.0482 20.5951C16.7981 20.3451 16.459 20.2046 16.1054 20.2046C15.7518 20.2046 15.4126 20.3451 15.1626 20.5951C14.9125 20.8452 14.772 21.1843 14.772 21.5379C14.772 21.8915 14.9125 22.2307 15.1626 22.4807C15.4126 22.7308 15.7518 22.8713 16.1054 22.8713Z"
      fill="currentColor"
    />
  </svg>
);
